import { Genset } from './Genset';
import assignToThis from '../../helper/assignToThis';
import { ObjectOnly } from '@/classes/ObjectOnly';

export class ScenarioGenerator {

  public isGeneratorBackup: boolean | null = null;

  public isMulti: boolean | null = null;

  // Begin Mono
  public hasDifferentGeneratorDayAndNightBefore: boolean | null = null;
  public generatorBeforeDay: Genset | null = null;
  public generatorBeforeNight: Genset | null = null;

  public hasDifferentGeneratorAfter: boolean | null = null;

  public hasDifferentGeneratorDayAndNightAfter: boolean | null = null;
  public generatorAfterDay: Genset | null = null;
  public generatorAfterNight: Genset | null = null;
  // End Mono only

  // Begin Multi
  public hasDifferentTypes: boolean | null = null;
  public generatorAfterType1: Genset | null = null;
  public generatorAfterType2: Genset | null = null;

  public srLoad: number | null = null;
  public srPV: number | null = null;
  public srPower: number | null = null;
  // End Multi


  public constructor(obj: ObjectOnly = {}) {
    assignToThis(this, obj);

    this.generatorBeforeDay = this.generatorBeforeDay ? new Genset(this.generatorBeforeDay) : null;
    this.generatorBeforeNight = this.generatorBeforeNight ? new Genset(this.generatorBeforeNight) : null;

    this.generatorAfterDay = this.generatorAfterDay ? new Genset(this.generatorAfterDay) : null;
    this.generatorAfterNight = this.generatorAfterNight ? new Genset(this.generatorAfterNight) : null;
  }

}
